import { queryClient, useMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { UserInvitation } from '../../../../shared/model-typings';
import type { CreateUserInvitationsRequest } from '../../../../typings/api';

import { userInvitationsQueryKey } from './useUserInvitations';

/**
 * Creates user invitations for the given organization.
 * We use a Set to ensure that the emails are unique.
 */
function createUserInvitations(organizationId: number, emails: Set<string>) {
  return post<CreateUserInvitationsRequest, UserInvitation[]>(`/api/organizations/${organizationId}/invite`, {
    emails: Array.from(emails),
  });
}

/**
 * Creates a mutation to create user invitations for the given organization.
 */
export default function useCreateUserInvitations(organizationId: number) {
  return useMutation({
    mutationFn: (emails: Set<string>) => createUserInvitations(organizationId, emails),
    onSuccess: () => {
      //  Re-fetch the user invitations query
      queryClient.invalidateQueries(userInvitationsQueryKey);
    },
  });
}
